import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { ActivityStore } from 'src/app/stores/resources/activity.store';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';
import { FireStorageService } from 'src/app/services/fire-storage.service';
import { STATUS_OBJECT, DISPLAY_STATUS_OBJECT } from 'src/app/dummy/status';
import { IVocabulary, IActivity } from 'src/app/interfaces/resource';
import { pushObjArray, ConvertService } from 'src/app/services/convert.service';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { DictionaryStore } from 'src/app/stores/dictionary.store';
import { AngularFireStorage } from '@angular/fire/storage';
import { AngularFirestore } from '@angular/fire/firestore';

@Component({
  selector: 'app-add-pos-word',
  templateUrl: './add-pos-word.component.html',
  styleUrls: ['./add-pos-word.component.scss']
})
export class AddPosWordComponent implements OnInit {

  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  TITLE = "Create new word"

  form: FormGroup;
  pos: AbstractControl;
  definition: AbstractControl;
  examples: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;

  SELECTED_PICTURE_FILE: any;
  SELECTED_SOUND_FILE: any;

  constructor(
    public dialogRef: MatDialogRef<AddPosWordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: DictionaryStore,
    private snackBar: MatSnackBar,
    private afs: AngularFirestore,
    private route: Router,
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      pos: [null, Validators.compose([Validators.required])],
      definition: [null, Validators.required],
      examples: [null],
      picfile: [null]
    })
  }

  async uploadFilePicture(event) {
    this.SELECTED_PICTURE_FILE = event.target.files[0];;
  }



  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    if (this.form.valid) {
      this.form.disable();
      const key = this.afs.createId()
      const row = {
        key: key,
        text: f.pos,
        definition: f.definition,
        examples: f.examples,
      }
      this.store.addPOS('dictionary', this.data, row, this.SELECTED_PICTURE_FILE, success => {
        this.snackBar.open("POS has been saved successful.", "Done", { duration: 1000 });
        this.processNew = false;
        this.processClose = false;
        if (!isNew) {
          this.dialogRef.close('no')
        }
        this.route.navigate([`/dictionary/dictionary-form/${this.data.key}`])
      })
    }
  }

}
